import AccountList from "../../components/home/AccountList";
import { IoBan, IoCloseCircle, IoCloseSharp, IoOpenOutline, IoSend } from "react-icons/io5";
import Spinner from "../../components/Spinner";
import { currencyFormat, message, setUnixToTimeFormat } from "../../utils/Funciones.js";
import { MdAddReaction, MdMovieFilter, MdReport } from "react-icons/md";
import { Pagination, PaginationItem, Stack, Button, IconButton, Tooltip, Box, CircularProgress } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import { FaBusinessTime, FaShippingFast, FaShopify } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import 'moment/locale/es';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import debounce from 'lodash.debounce';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { SET_TO_DEFAULT_RESPONSE, createMessageReport, getByPageByUserId } from "../../store/features/slices/socialSlice";
import { uriSerialized } from "../../utils/uriSerialized";
import { Input, InputGroup, InputLeftElement, InputRightElement } from "@chakra-ui/react";
import { FiSearch } from "react-icons/fi";
import { FaCoins, FaCommentDots, FaGavel, FaHandHoldingDollar, FaHourglassStart, FaSquareCheck, FaUserTag } from "react-icons/fa6";
import Modal from "../../components/modal/Modal";
import SpinnerData from "../../components/SpinnerData";
import { useTranslation } from 'react-i18next';

const UserSocialOrders = ({ }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { userToken, user } = useSelector((state) => state.userReducer);
  const messagesEndRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [pedidosByState, SetPedidosByState] = useState('')
  const [limit, setLimit] = useState(30);
  const [reportorder, setReportOrder] = useState({
    _id: "",
    open: false,
    message: "",
    ventaId: "",
    orderId: "",
    chat: [],
    nameplataform: "",
    plataformlogo: "",
  })

  const [curTime, SetCurTime] = useState(null)


  const {
    ventasByPage,
    isMutation,
    totalFilter,
    total
  } = useSelector((state) => state.socialReducer);

  const {
    userInfo
  } = useSelector((state) => state.userReducer);

  useEffect(() => {
    if (isMutation.success) {
      message(isMutation.message, 'success', 5)
      dispatch(SET_TO_DEFAULT_RESPONSE())
    }

    const queryOptions = {
      id: userToken && user?.id,
      page: currentPage,
      limit: limit,
      search: searchTerm.trim(),
    }
    const query = queryOptions ? "?" + uriSerialized(queryOptions) : ""
    dispatch(getByPageByUserId(query))
  }, [dispatch, searchTerm.trim(), currentPage, limit, isMutation.success]);

  useEffect(() => {
    if (isMutation.updated) {
      //message(isMutation.message, 'success', 5)
      setReportOrder({ ...reportorder, message: "", chat: isMutation.extra.chat })
      scrollToBottom();
      dispatch(SET_TO_DEFAULT_RESPONSE())
    }
  }, [isMutation.updated]);

  useEffect(() => {
    setInterval(function () {
      SetCurTime(new Date().toLocaleString());
    }.bind(this), 1000);
  }, [])

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleReportOrder = (_id, orderId, nameplataform, logo, ventaId, chat) => {
    setReportOrder({ ...reportorder, open: true, _id: _id, orderId: orderId, nameplataform: nameplataform, plataformlogo: logo, ventaId: ventaId, chat: chat });
  }

  const handleSubmitReportOrder = e => {
    e.preventDefault()
    dispatch(createMessageReport({ type: 'NEW_MESSAGE', _id: reportorder._id, message: reportorder.message, userId: userToken && user?.id }))
  }

  const handleChangePage = (e, p) => {
    setCurrentPage(p);
  };

  const changeHandleSearch = (event) => {
    SetPedidosByState('')
    setSearchTerm(event.target.value)
    setCurrentPage(1);
  }

  const debouncedChangeHandler = useMemo(() => debounce(changeHandleSearch, 500), []);

  const onCopy = (text) => {
    message(text, 'success', 2)
  }

  const onChangeSearchTermClear = e => {
    setSearchTerm("");
    setCurrentPage(1)
    document.getElementById("search").value = "";
  };

  return (
    <AccountList>

      {/* HEADER PAGES */}
      <div className="fixed mt-8 p-4 flex flex-wrap text-brand-900 dark:text-brand-100 uppercase w-[calc(100%-30px)] font-semibold md:w-[calc(100%-80px)] lg:w-[calc(100%-320px)] bg-gradient-to-r from-white dark:from-brand-900 backdrop-blur-lg z-30 rounded-xl">
        <div className="w-full h-14 text-lg md:text-2xl flex items-center">
          <div className="flex items-center w-full">
            <FaShopify size={65} style={{ marginRight: 10 }} />
            {t('mysmmorders')}
            <div class="flex items-center justify-center px-3 ml-3 text-2xl font-medium bg-brand-200 dark:bg-brand-800 text-brand-900 dark:text-brand-200 rounded-full">
              {!isMutation.loading && total}
            </div>
          </div>
        </div>
        <div className="mt-3 !w-full md:!w-[450px] md:!max-w-[450px]">
          <InputGroup className="w-full md:w-[450px] md:max-w-[450px]">
            <InputLeftElement pointerEvents="none" className="!mt-[14px] !ml-2">
              <FiSearch size={24} className="text-brand-900 dark:text-brand-100" />
            </InputLeftElement>
            <Input size='lg' autoFocus id="search" variant='flushed' onChange={debouncedChangeHandler} type="text" placeholder={t('searchorders') + '...'} className="flex w-full md:w-[450px] md:max-w-[450px] !h-14 !pl-10 !items-center !justify-center !border-2 rounded-xl !bg-brand-200 
            dark:!bg-brand-950 !text-sm focus:!ring-lightPrimary dark:focus:!ring-darkPrimary focus:!border-lightPrimary dark:focus:!border-darkPrimary 
            !outline-none !border-brand-300 dark:!border-brand-800 !text-brand-900 dark:!text-white !relative !placeholder-brand-500" />
            <InputRightElement className="!mt-[8px] !mr-1">
              <IconButton onClick={onChangeSearchTermClear} className={`mr-2 ${searchTerm.trim().length > 0 ? 'scale-100' : 'scale-0'} transition-all duration-500 text-brand-600 dark:text-brand-300`}>
                <IoCloseSharp size={20} className="text-brand-900 dark:text-brand-100" />
              </IconButton>
            </InputRightElement>
          </InputGroup>
        </div>
      </div>

      <div className="w-[calc(100%-1.50rem)] md:w-[calc(100%-1.50rem)] lg:w-[calc(100%-26.50rem)] mb-0 mt-[160px] pb-3 pt-5 md:pt-5 lg:pt-10 fixed z-20 bg-white/10 dark:bg-[#00000023] backdrop-blur-lg flex flex-col md:flex-col lg:flex-row items-center">
        <div className="w-full flex items-center justify-center md:justify-end text-brand-800 dark:text-brand-200 mt-0 h-10">
          <div className="hidden md:block">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(!isMutation.loading && Number(totalFilter) / limit)}
                page={currentPage}
                onChange={handleChangePage}
                variant="text"
                color="primary"
                shape="rounded"
                size="large"
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                    {...item}
                  />
                )}
                className="bg-white dark:bg-brand-900"
              />
            </Stack>
          </div>
          <div className="block md:hidden">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(!isMutation.loading && Number(totalFilter) / limit)}
                page={currentPage}
                onChange={handleChangePage}
                variant="text"
                color="primary"
                shape="rounded"
                size="small"
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                    {...item}
                  />
                )}
                className="bg-white dark:bg-brand-900"
              />
            </Stack>
          </div>
        </div>
      </div>

      <Modal
        open={reportorder.open}
        onClose={() => setReportOrder({
          ...reportorder,
          _id: "",
          open: false,
          message: "",
          orderId: "",
          nameplataform: "",
          plataformlogo: ""
        })}
        headerTitle={`Chat de ${reportorder.ventaId}`}
      >
        <div className="h-[calc(100vh-150px)] relative m-auto w-full">
          <div className="grid grid-wrap w-full md:w-4/12 mb-5">
            <div className="flex inline-flex items-center relative">
              <LazyLoadImage
                class="w-14 h-14 z-30 rounded-full flex inline-flex object-cover"
                alt={`No image ${reportorder.nameplataform}`}
                effect="blur"
                src={`/images/logos/${reportorder.plataformlogo}`}
              />
              <div className="grid self-center">
                <div className="ml-2 text-base font-semibold text-brand-900 dark:text-brand-200 capitalize">{reportorder.nameplataform}</div>
              </div>
            </div>
          </div>

          <div className="h-[calc(100vh-300px)] overflow-y-auto flex flex-col space-y-4 p-4 bg-brand-100 dark:bg-brand-900">
            {reportorder.chat.map((msg, index) => (
              <div>
                <div
                  key={index}
                  className={`flex ${msg?.user === user?.id ? 'justify-end' : 'justify-start'
                    }`}
                >
                  <div
                    className={`max-w-xs p-4 rounded-lg ${msg?.user === user?.id
                      ? 'bg-[#00008b] text-white'
                      : 'bg-brand-300 text-black'
                      }`}
                  >
                    <p>{msg.message}</p>
                    <span className={`text-xs ${msg?.user === user?.id
                      ? 'text-brand-500'
                      : 'text-brand-700'
                      }`}>
                      {moment(msg.create_at).fromNow()}
                    </span>
                  </div>
                </div>
              </div>
            ))}
            {
              reportorder.chat.at(-1)?.user === user?.id &&
              <div className="flex items-center mt-5">
                <div className="mr-2 animate-pulse text-brand-900 dark:text-brand-100">{t('waitinganswer')} ...</div> <Spinner />
              </div>
            }
            <div ref={messagesEndRef} />
          </div>

          <div className="absolute w-full bottom-0 left-0 flex items-center gap-2">
            <input
              className="custom-style-input"
              value={reportorder.message}
              maxLength={255}
              onChange={(e) => setReportOrder({ ...reportorder, message: e.target.value })}
              placeholder={t('typemessage') + '...'}
            />
            <Button onClick={handleSubmitReportOrder} disabled={(isMutation.uloading || reportorder.message.trim().length < 1) ? true : false} variant="contained" sx={{ maxWidth: 65, minWidth: 65, maxHeight: 50, minHeight: 50 }} className="rounded-xl !bg-blue-500 !px-2 !py-2 !text-white transition !duration-200 hover:!bg-blue-600 active:!bg-blue-700 dark:!bg-blue-400 dark:!text-white dark:hover:!bg-blue-300 dark:active:!bg-blue-200">
              <IoSend className="w-5 h-5 text-white" />
            </Button>
          </div>
        </div>
      </Modal>

      <div className="relative w-full mt-[275px]">
        {!isMutation.loading ? ventasByPage.length > 0 ?
          <div>
            {ventasByPage.map((order) => {
              var sublogo = ""
              var nameplataform = ""
              var servicename = ""

              sublogo = order.plataform?.sublogo
              nameplataform = order.plataform?.name
              servicename = order.service?.name

              return (
                <div className={`p-4 relative w-full shadow-xl shadow-neutral-200 dark:shadow-none cursor-pointer md:w-12/12 bg-white dark:bg-brand-900 text-brand-900 dark:text-brand-200 flex flex-wrap mb-14 rounded-tr-lg rounded-br-lg rounded-bl-lg animation`} key={order._id}>
                  <label className={`absolute -top-10 left-0 p-2 flex items-center text-brand-800 dark:text-brand-200 text-base rounded-tl-lg rounded-tr-lg bg-white dark:bg-brand-900`}>
                    <span className="text-[12px]">{order.ventaId}</span>
                  </label>
                  <div className="flex flex-wrap items-center w-full md:w-full lg:w-[20%]">
                    <div className="flex inline-flex items-center">
                      <LazyLoadImage
                        className="object-cover max-w-[45px] min-w-[45px] max-h-[45px] min-h-[45px] z-10 rounded-full flex inline-flex"
                        alt={`No image ${nameplataform}`}
                        effect="blur"
                        src={`/images/logos/${sublogo}`}
                      />
                      <div className="grid gap-1 self-center">
                        <div className="ml-2 text-sm capitalize font-semibold">{nameplataform}</div>
                        <div className="ml-2 text-xs truncate ...">{servicename}</div>
                        <div className="ml-2 text-xs truncate ...">{setUnixToTimeFormat('created_at', order.created_at)}</div>
                      </div>
                    </div>
                  </div>

                  <div className="relative grid md:grid lg:flex grid-cols-2 md:grid-cols-3 lg:grid-cols-1 gap-3 items-center w-full md:w-full lg:w-[calc(80%-150px)] mt-5 md:mt-4 lg:mt-0">

                    <div className="w-full md:w-full lg:w-[8.27%] grid">
                      <div className="flex items-center justify-center uppercase text-sm">{t('link')}</div>
                      <div className="flex items-center justify-center">
                        <div className="flex inline-flex items-center">
                          <div class="text-center text-indigo-950 dark:text-indigo-50 bg-gradient-to-r from-indigo-400 dark:from-indigo-500 rounded-l-lg flex items-center p-2">
                            <a href={`${order.link}`} target="_blank" className=""><IoOpenOutline size={24} /></a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="w-full md:w-full lg:w-[14.27%] grid">
                      <div className="flex items-center justify-center uppercase text-sm">{t('quantity')}</div>
                      <div className="flex items-center justify-center">
                        <div className="flex inline-flex items-center">
                          <div class="text-center text-blue-950 dark:text-blue-50 bg-gradient-to-r from-blue-400 dark:from-blue-500 rounded-l-lg flex items-center p-2">
                            <MdAddReaction size={24} className="mr-2" />{order.quantity}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="w-full md:w-full lg:w-[14.27%] grid">
                      <div className="flex items-center justify-center uppercase text-sm">{t('totalcost')}</div>
                      <div className="flex items-center justify-center">
                        <div className="flex inline-flex items-center">
                          {
                            userInfo?.reseller ?
                              <div class="text-center text-amber-950 dark:text-amber-50 bg-gradient-to-r from-amber-400 dark:from-amber-500 rounded-l-lg flex items-center p-2">
                                <FaCoins size={24} className="mr-2" />{currencyFormat(order.totalamount)}
                              </div>
                              :
                              <div class="text-center text-green-950 dark:text-green-50 bg-gradient-to-r from-green-400 dark:from-green-500 rounded-l-lg flex items-center p-2">
                                <FaUserTag size={24} className="mr-2" />{currencyFormat(order.totalamount)}
                              </div>
                          }
                        </div>
                      </div>
                    </div>

                    <div className="w-full md:w-full lg:w-[14.27%] grid">
                      <div className="flex items-center justify-center uppercase text-sm">{t('startend')}</div>
                      <div className="flex items-center justify-center">
                        <div className="flex inline-flex items-center">
                          <div class="text-center text-cyan-950 dark:text-cyan-50 bg-gradient-to-r from-cyan-400 dark:from-cyan-500 rounded-l-lg flex items-center p-2">
                            <MdMovieFilter size={24} className="mr-2" />{order.start_count + ' / ' + (order.start_count + order.quantity)}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="w-full md:w-full lg:w-[14.27%] grid">
                      <div className="flex items-center justify-center uppercase text-sm">{t('progress')}</div>
                      <div className="flex items-center justify-center">
                        <div className="flex inline-flex items-center">
                          <Box position="relative" display="inline-flex">
                            <CircularProgress
                              variant="determinate"
                              value={(100 / (order.quantity / (order.quantity - order.remains)))}
                              color={`${((100 / (order.quantity / (order.quantity - order.remains))) >= 0 && (100 / (order.quantity / (order.quantity - order.remains))) < 50) ? 'success' : ((100 / (order.quantity / (order.quantity - order.remains))) >= 50 && (100 / (order.quantity / (order.quantity - order.remains))) < 100) ? 'warning' : 'error'}`}
                              size={60}
                              thickness={6}
                            />
                            <Box
                              top={0}
                              left={0}
                              bottom={0}
                              right={0}
                              position="absolute"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <span className="text-sm font-bold">{`${((100 / (order.quantity / (order.quantity - order.remains)))).toFixed(0)}%`}</span>
                            </Box>
                          </Box>
                        </div>
                      </div>
                    </div>

                    <div className="w-full md:w-full lg:w-[14.27%] grid">
                      <div className="flex items-center justify-center uppercase text-sm">{t('missing')}</div>
                      <div className="flex items-center justify-center">
                        <div className="flex inline-flex items-center">
                          <div class="text-center text-blue-950 dark:text-blue-50 bg-gradient-to-r from-blue-400 dark:from-blue-500 rounded-l-lg flex items-center p-2">
                            <FaHourglassStart size={24} className="mr-2" />{order.remains}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="w-full md:w-full lg:w-[20.27%] grid">
                      <div className="flex items-center justify-center uppercase text-sm">{t('status')}</div>
                      <div className="flex items-center justify-center">
                        <div className="flex inline-flex items-center">
                          {order.state === "Completed" && <div class="text-center text-green-950 dark:text-green-50 bg-gradient-to-r from-green-400 dark:from-green-500 rounded-l-lg flex items-center p-2"><FaSquareCheck size={24} className="mr-2" />{t('completed')}</div>}
                          {order.state === "Partial" && <div class="text-center text-brand-950 dark:text-brand-50 bg-gradient-to-r from-brand-400 dark:from-brand-500 rounded-l-lg flex items-center p-2"><FaHandHoldingDollar size={24} className="mr-2" />{t('rpartial')}</div>}
                          {order.state === "Checking" && <div class="text-center text-brand-950 dark:text-brand-50 bg-gradient-to-r from-brand-400 dark:from-brand-500 rounded-l-lg flex items-center p-2"><FaGavel size={24} className="mr-2" />{t('inrevew')}</div>}
                          {(order.state === "Processing" || order.state === "In progress") && <div class="text-center text-amber-950 dark:text-amber-50 bg-gradient-to-r from-amber-400 dark:from-amber-500 rounded-l-lg flex items-center p-2"><FaBusinessTime size={24} className="mr-2" />{t('proccessing')}</div>}
                          {order.state === "Pending" && <div class="text-center text-yellow-950 dark:text-yellow-50 bg-gradient-to-r from-yellow-400 dark:from-yellow-500 rounded-l-lg flex items-center p-2"><FaShippingFast size={24} className="mr-2" />{t('pending')}</div>}
                          {order.state === "Rejected" && <div class="text-center text-red-950 dark:text-red-50 bg-gradient-to-r from-red-400 dark:from-red-500 rounded-l-lg flex items-center p-2"><IoBan size={24} className="mr-2" />{t('rejected')}</div>}
                          {order.state === "Refunded" && <div class="text-center text-cyan-950 dark:text-cyan-50 bg-gradient-to-r from-cyan-400 dark:from-cyan-500 rounded-l-lg flex items-center p-2"><FaHandHoldingDollar size={24} className="mr-2" />{t('refunded')}</div>}
                          {order.state === "Canceled" && <div class="text-center text-red-950 dark:text-red-50 bg-gradient-to-r from-red-400 dark:from-red-500 rounded-l-lg flex items-center p-2"><IoCloseCircle size={24} className="mr-2" />{t('canceled')}</div>}
                        </div>
                      </div>
                      <div className="text-xs text-center">{moment(order.last_update).fromNow()}</div>
                    </div>
                  </div>

                  <div className="flex items-center gap-2 justify-end w-full md:w-full lg:md:w-[150px] mt-5 md:mt-5 lg:mt-0">
                    <Tooltip title={t('report')} arrow={true}>
                      <Button onClick={() => handleReportOrder(order._id, order.orderId, nameplataform, sublogo, order.ventaId, order.chat)} disabled={(order.state === "Completed" || order.state === "Refunded" || order.state === "Partial" || order.state === "Canceled") ? true : false} variant="contained" sx={{ maxWidth: 35, minWidth: 35, maxHeight: 35, minHeight: 35, position: "relative" }} className="rounded-xl !bg-blue-500 !px-2 !py-2 !text-white transition !duration-200 hover:!bg-blue-600 active:!bg-blue-700 dark:!bg-blue-400 dark:!text-white dark:hover:!bg-blue-300 dark:active:!bg-blue-200">
                        <FaCommentDots className="w-5 h-5 text-white" />
                        {
                          order.chat.length > 0 &&
                          <div className="absolute z-10 flex items-center justify-center font-semibold max-w-[30px] min-w-[30px] max-h-[30px] min-h-[30px] -top-4 -right-4 p-2 rounded-full bg-red-500 text-white text-sm">{order.chat.length}</div>
                        }
                      </Button>
                    </Tooltip>
                  </div>
                </div>
              )
            })}
          </div> : <div className="alert-danger font-semibold mt-[275px]">{t('nodatasearchorders')}</div> : <div className="mt-[275px]"><SpinnerData>{t('loadingdatawait')}...</SpinnerData></div>}
      </div>
    </AccountList >
  );
};

export default UserSocialOrders;
